import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

export type OnlyZeroValuesForBubbleSizeSelectedComponentArgs = {
  openBubbleChartSettings: OnButtonClick;
  i18nLocale: I18nLocale;
};

export const onlyZeroValuesForBubbleSizeSelectedComponent = ({
  openBubbleChartSettings,
  i18nLocale,
}: OnlyZeroValuesForBubbleSizeSelectedComponentArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.onlyZeroValuesForBubbleSizeSelectedComponent.title',
    'The selected component type has only 0 in the Bubble size field'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.onlyZeroValuesForBubbleSizeSelectedComponent.description',
    'Change your Bubble chart settings to show size 0 bubbles, select a different component type or a different Bubble size field.'
  ),
  children: (
    <PrimaryButton onClick={openBubbleChartSettings}>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.onlyZeroValuesForBubbleSizeSelectedComponent.bubbleChartSettings',
        'Bubble chart settings'
      )}
    </PrimaryButton>
  ),
});
